<template>
  <div class="Values">
    <section class="Values-text">
      <h4 class="title">{{ $t('jobs_page.header_four') }}</h4>
      <p class="text">
        {{ $t('jobs_page.body_four') }}
      </p>
    </section>
    <section class="Boxes">
      <BoxIcon
        svgPath="brain"
        :title="$t('jobs_page.card1_title')"
        :text="$t('jobs_page.card1_txt')"
        ><Brain
      /></BoxIcon>
      <BoxIcon
        svgPath="people"
        :title="$t('jobs_page.card2_title')"
        :text="$t('jobs_page.card2_txt')"
      >
        <People />
      </BoxIcon>
      <BoxIcon
        svgPath="rocket"
        :title="$t('jobs_page.card3_title')"
        :text="$t('jobs_page.card3_txt')"
      >
        <Rocket />
      </BoxIcon>
    </section>
  </div>
</template>

<script>
import Brain from './brain.vue';
import Rocket from './rocket.vue';
import People from './people.vue';
import BoxIcon from './BoxIcon.vue';

export default {
  name: 'OurValues',
  components: {
    BoxIcon,
    Brain,
    Rocket,
    People,
  },
};
</script>

<style scoped>
.Values {
  min-height: 750px;
  color: white;
  background: #2b4047;
  display: grid;
  --values-text-f-size: 14px;
  --values-text-max-size: 80%;
  --values-text-bottom-margin: 2em;
  --values-text-margin: 2em auto 4em auto;
  --values-title-f-size: 30px;
  --values-grid-rows: auto 1fr;
  --values-title-margin: 2.5em;
  grid-template-rows: var(--values-grid-rows);
  padding-bottom: 100px;
}
.title {
  font-size: var(--values-title-f-size);
  font-family: 'Foco';
  margin-top: var(--values-title-margin);
  text-align: center;
}
.text {
  font-size: var(--values-text-f-size);
  text-align: center;
  max-width: var(--values-text-max-size);
  margin: var(--values-text-margin);
}
.Boxes {
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}
@media (min-width: 768px) {
  .Values {
    --values-grid-rows: 0.8fr 1fr;
    --values-text-f-size: 18px;
    --values-text-max-size: 55%;
    --values-text-margin: 2em auto 0 auto;
    --values-title-f-size: 32px;
    padding-bottom: 20px;
  }
  .Boxes {
    flex-direction: row;
  }
}
</style>
